module.exports = __webpack_public_path__ + "img/deterministic_signals_log.cc4b613a.png";